import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';

import { PadraoService } from "../service/padrao.service";
import { Locale } from "../util/locale.ptbr";
import { Helpers } from '../util/helpers';
import { BaseComponent } from './base.component';

@Component({template:''})
export class BaseStepComponent extends BaseComponent implements OnInit {

    @Input("form") cadastro : FormGroup;
    @Input() acao : string = "";
    
}


// WEBPACK FOOTER //
// ./src/app/base/base-step.component.ts